import { LevelSelectionManager } from "./LevelSelectionManager";
import { LevelSelectionGUI } from "./LevelSelectionGUI";
import { GameVars } from "../../GameVars";
import { AudioManager } from "../../AudioManager";

export class LevelSelectionScene extends Phaser.Scene {

    public static currentInstance: LevelSelectionScene;

    public levelSelectionManager: LevelSelectionManager; 
    public levelSelectionGUI: LevelSelectionGUI; 
      
    constructor() {

        super({key: "LevelSelectionScene"});
    }

    public create(): void {      
        
        AudioManager.SetVolume(1); 

        LevelSelectionScene.currentInstance = this;  
        GameVars.currentScene = this;

        this.levelSelectionGUI = new LevelSelectionGUI(this); 
        this.add.existing(this.levelSelectionGUI); 

        this.levelSelectionManager = new LevelSelectionManager(this); 
        this.add.existing(this.levelSelectionManager); 

        this.input.keyboard.on("keydown-SPACE", function() {
            this.goToBoardState(); 
        }, this);           
    }
}
